import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import BackgroundVideo from 'components/BackgroundVideo';
import ResponsiveImage from 'components/ResponsiveImage';
import Photographer from 'components/Photographer';
import ResponsiveImageSource from 'components/Models/ResponsiveImageSource';
import './BackgroundMedia.scss';

const BackgroundMedia = ({
  image,
  video,
  className,
  photographer,
  photographerClassName,
  imageSources,
  imageFetchPriority,
  imageLoading,
}) => {
  return video || image ? (
    <div className={cn('background-media', className)}>
      {video && video.url ? (
        <BackgroundVideo {...video} className="background-media__video" />
      ) : (
        <React.Fragment>
          {image && (
            <ResponsiveImage
              {...image}
              fluid
              fetchPriority={imageFetchPriority}
              loading={imageLoading}
              sources={imageSources}
              className="background-media__image"
            />
          )}
        </React.Fragment>
      )}
      {photographer && (
        <Photographer className={photographerClassName} {...photographer} />
      )}
    </div>
  ) : null;
};

BackgroundMedia.propTypes = {
  photographer: PropTypes.exact(Photographer.propTypes),
  photographerClassName: PropTypes.string,
  image: PropTypes.exact(ResponsiveImage.propTypes),
  video: PropTypes.exact(BackgroundVideo.propTypes),
  className: PropTypes.string,
  imageSources: PropTypes.arrayOf(ResponsiveImageSource.propTypes),
  imageFetchPriority: PropTypes.oneOf(['high', 'low', 'auto']),
  imageLoading: PropTypes.oneOf(['eager', 'lazy']),
};

BackgroundMedia.propTypesMeta = {
  imageSources: 'exclude',
  imageFetchPriority: 'exclude',
  imageLoading: 'exclude',
};

export default BackgroundMedia;
